import { request, COMPANY_ID } from './apiClient';

export const getAllFolders = async () => {
  const url = `/company/${COMPANY_ID}/folders`;
  console.log(`[getAllFolders] Calling: ${url}`);
  return await request(url);
};

export const getFolderByName = async (folderName: string) => {
  const url = `/company/${COMPANY_ID}/folders/folder/name/${encodeURIComponent(folderName)}`;
  console.log(`[getFolderByName] Calling: ${url}`);
  return await request(url);
};

export const createFolder = async (folderName: string, companyId: string, parentFolderId?: string) => {

  const url = `/company/${COMPANY_ID}/folders/folder`;
  console.log(`[createFolder] Calling: ${url} with folderName=${folderName}`);
  return await request(url, {
    method: 'POST',
    body: JSON.stringify({ folderName, companyId, parentFolderId: parentFolderId || null }),
  }, 'application/json');
};

export const deleteFolder = async (folderId: string) => {
  const url = `/company/${COMPANY_ID}/folders/folder/${folderId}`;
  console.log(`[deleteFolder] Calling: ${url} with folderId=${folderId}`);
  return await request(url, {
    method: 'DELETE',
  }, 'application/json');
};

export const updateFolder = async (folderId: string, folderName: string, companyId: string) => {
  const url = `/company/${COMPANY_ID}/folders/folder/${folderId}`;
  console.log(`[updateFolder] Calling: ${url} with folderId=${folderId}`);
  return await request(url, {
    method: 'PUT',
    body: JSON.stringify({ folderName, companyId }),
  }, 'application/json');
};

export const moveFolder = async (folderId: string, targetParentFolderId: string | null) => {
  const url = `/company/${COMPANY_ID}/folders/folder/${folderId}/move`;
  console.log(`[moveFolder] Calling: ${url} with targetParentFolderId=${targetParentFolderId}`);

  return await request(url, {
    method: 'PUT',
    body: JSON.stringify({ parentFolderId: targetParentFolderId }),
  }, 'application/json');
};

export const reorderFolders = async (
  parentFolderId: string | null,
  orderedFolderIds: string[]
) => {
  const url = `/company/${COMPANY_ID}/folders/reorder`;
  console.log(`[reorderFolders] Calling: ${url} with parentFolderId=${parentFolderId}`);

  return await request(url, {
    method: 'PUT',
    body: JSON.stringify({
      parentFolderId,
      orderedFolderIds,
    }),
  }, 'application/json');
};

export const updateFolderAccess = async (userId: string, permissions: { folderId: string, access: boolean }[]) => {
  const url = `/company/${COMPANY_ID}/folder/access`;
  console.log(`[updateFolderAccess] Calling: ${url} with userId=${userId}`);
  return await request(url, {
    method: 'PUT',
    body: JSON.stringify({
      user: { userId },
      company: { companyId: COMPANY_ID },
      permissions,
    }),
  }, 'application/json');
};

export const getFolderAccess = async (userId: string): Promise<{ folderId: string; access: boolean }[]> => {
  const url = `/company/${COMPANY_ID}/folder/access/${userId}`;
  console.log(`[getFolderAccess] Calling: ${url}`);
  return await request(url);
};
